import React from "react";

const SkeletonCartUpsells = () => (
	<div role="status" className="w-full animate-pulse">
		<div className="mt-12">
			<div className="h-8 w-40 bg-gray-300 rounded mb-6" />
			<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
				<div className="h-40 bg-gray-300 rounded" />
				<div className="h-40 bg-gray-300 rounded" />
				<div className="h-40 bg-gray-300 rounded" />
				<div className="h-40 bg-gray-300 rounded" />
			</div>
		</div>
	</div>
);
export default SkeletonCartUpsells;